import React from 'react'
import style from './Error404.module.css'

export default function Error404() {
    return (
        <div className={style.Container}>
            <h1>404</h1>
            <p>Page Not Found</p>
        </div>
    )
}
